import styled from "styled-components";
import {css} from "styled-components";

export const SidebarInfoStyle = styled.div`
  position: absolute;
  left: 12px;
  top: 12px;
  bottom: 12px;
  z-index: 200;

  transition: all 0.3s ease-in-out;

  .pro-sidebar {
    background-color: #161a1d;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: visible;
    width: 100%;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 10px;
    padding-left: 10px;
  }
  .pro-sidebar-menu {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: visible;
    width: 100%;
  }

  &::-webkit-scrollbar {
    width: 15px;
    transition: width 0.3s ease;
  }

  &::-webkit-scrollbar-track {
    background: #1d2133;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #4e5574;
    border-radius: 10px;
    border: 3px solid #1d2133;
    transition: border-width 0.3s ease;
  }

  &::-webkit-scrollbar:hover {
    width: 16px;
  }

  &::-webkit-scrollbar-thumb:hover {
    border-width: 2px;
  }

  /* Scrollbar styles for Firefox */
  scrollbar-color: #4e5574 #1d2133;
  scrollbar-width: thin;

  /* &::-webkit-scrollbar: {
  scrollbar-width: auto;
} */
`;

export const MenuItemBtn = styled.div<{
  $isactive: string;
  $isbtn: string;
  $isopenpanel?: string;
  $isblockvisible?: string;
}>`
  cursor: auto;
  display: flex;
  align-items: center;
  /* justify-content: ${(props) =>
    props.$isopenpanel === "true" ? "flex-start" : "center"}; */
  justify-content: flex-start;
  overflow: visible;
  opacity: ${(props) => (props.$isactive === "true" ? "1" : "0.7")};
  background-color: ${(props) =>
    props.$isactive === "true" ? "rgba(255, 255, 255, 0.1)" : null};
  border-radius: 10px;
  border: ${(props) =>
    props.$isactive === "true" ? "1px solid #0082ED" : "1px solid transparent"};
  padding: 10px 0 10px 8px;
  margin: 3px 8px 3px 0;
  gap: 10px;

  cursor: ${(props) => (props.$isbtn === "true" ? "pointer" : "default")};
  transition: all 0.3s ease-in-out;

  span {
    display: ${(props) =>
      props.$isblockvisible === "true" ? "block" : "none"};
    color: #ffffff;
    white-space: nowrap;
    font-weight: 600;
  }
  &:hover {
    opacity: 1;
  }
`;

export const ImgIconWrapper = styled.div<{isrotate?: string}>`
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  rotate: ${(props) => (props.isrotate === "true" ? "180deg" : "0deg")};
`;

export const BtnSearch = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 0 23px 0 13px;
  align-items: center;
  width: 100%;
  opacity: 1;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  position: relative;
  /* top: 150px; */
  left: 0;
  right: 0;
  bottom: 0;

  &:hover {
    opacity: 1;
  }
`;

export const SidebarItemBlock = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 5px;
`;

export const ToggleBtnPanel = styled.div<{
  isactive?: string;
  isrotateimg?: string;
  addstyle?: string;
}>`
  width: 100%;
  height: 20px;
  display: flex;
  /* justify-content: ${(props) =>
    props.isactive === "true" ? "flex-start" : "center"}; */
  justify-content: flex-start;
  align-items: center;
  /* padding-left: ${(props) => (props.isactive === "true" ? "15px" : "0")}; */
  gap: 10px;
  margin-bottom: 20px;
  cursor: pointer;
  ${(props) =>
    props.addstyle &&
    css`
      ${props.addstyle}
    `};

  img {
    rotate: ${(props) => (props.isrotateimg === "true" ? "0deg" : "180deg")};
  }

  span {
    display: ${(props) => (props.isactive === "true" ? "block" : "none")};
    color: #ffffff;
    white-space: nowrap;
  }
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: #151825;
  padding: 5px;
`;

export const SearchInput = styled.input`
  width: 100%;
  background-color: #151825;
  border: none;
  color: #ffffff;
  padding: 5px 10px;
  outline: none;

  &::placeholder {
    color: #737da8;
  }
`;

export const SearchIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 5px;
  margin-right: 10px;
  cursor: pointer;
`;

export const SearchResultBlock = styled.div<{isShow: boolean}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 15px 10px 0;
  cursor: pointer;

  .titleBlock {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: start;
    color: #ffffff;
  }

  img {
    rotate: ${(props) => (props.isShow ? "0deg" : "180deg")};
    transition: all 0.3s ease-in-out;
  }

  span {
    color: #fff;
  }

  .countBlock {
    background: #4d525b;
    color: white;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }
`;

export const ResultSearchContent = styled.div`
  .directions-block-enter {
    opacity: 0;
    transform: scaleY(0);
  }

  .directions-block-enter.directions-block-enter-active {
    opacity: 1;
    transform: scaleY(1);
    transition: opacity 300ms, transform 300ms;
  }

  .directions-block-leave {
    opacity: 1;
    transform: scaleY(1);
  }

  .directions-block-leave.directions-block-leave-active {
    opacity: 0;
    transform: scaleY(0);
    transition: opacity 300ms, transform 300ms;
  }
  p {
    font-size: 13px;
    margin: 5px 0;
    padding: 5px 10px;
    line-height: 1;

    &:hover {
      background-color: #4e5574;
    }
  }
`;

export const ResultSearchContentSidebarCard = styled.div`
  .directions-block-enter {
    opacity: 0;
    transform: scaleY(0);
  }

  .directions-block-enter.directions-block-enter-active {
    opacity: 1;
    transform: scaleY(1);
    transition: opacity 300ms, transform 300ms;
  }

  .directions-block-leave {
    opacity: 1;
    transform: scaleY(1);
  }

  .directions-block-leave.directions-block-leave-active {
    opacity: 0;
    transform: scaleY(0);
    transition: opacity 300ms, transform 300ms;
  }

  .titleSearchItem {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0 20px;

    .toggleArrowImg {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      transition: all 0.2s ease-in-out;
    }
    :hover > .toggleArrowImg {
      background-color: rgba(255, 255, 255, 0.3);
    }
  }
  p {
    font-size: 13px;
    margin: 5px 0;
    padding: 5px 10px;
    line-height: 1;
  }
`;
